import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';
import { FiatCurrencySchema } from '../types/FiatCurrency.types';

export const CurrencyEnum = FiatCurrencySchema;

export const BundleDtoPresentation = z.object({
  dailyBonusUpTo: z.number(),
  isVipBundle: z.boolean().optional(),
});

// Bundle DTO Schema
export const BundleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.string().optional(),
  priority: z.number(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number(),
  price: z.number(),
  isSale: z.boolean(),
  salePrice: z.number().nullable(),
  cover: MediaDtoSchema,
  presentation: BundleDtoPresentation.nullable(),
  isActive: z.boolean(),
  // Product ids of the bundles grouped under this one as "show more" children.
  relatedProductIds: z.array(z.string()).optional(),
  isOneTimePurchase: z.boolean().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  updatedBy: z.string(),
});

export const OrderBundleDtoSchema = z.object({
  id: z.string().uuid(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number().optional(),
  price: z.number(),
  isSale: z.boolean(),
  salePrice: z.number().nullable(),
  currency: CurrencyEnum,
});

export type BundleDto = z.infer<typeof BundleDtoSchema>;
export type OrderBundleDto = z.infer<typeof OrderBundleDtoSchema>;
